import { gql } from '@apollo/client';

const BoardQuery = gql`
	query BoardQuery($boardID: ID!) {
		boardByID(boardID: $boardID) {
			_id
			name
			url
		}
	}
`;

export default BoardQuery;
